/**
 * Return the basket items/answers.
 */

import type { RootState } from '/business/shared/state/store';
import type { BasketItem } from '/business/shared/state/reducers/basket';

export default (state: RootState): BasketItem[] => state.basket?.items || [];
